import { createContext } from 'react';

export const featuresContext = createContext([]);
